import React from 'react';

import { Icon, IconTypes } from '@eika/icon';
import { ListPanel } from '@eika/link-panel';

import piwik from '@/piwik/piwik';

import { useLinkProducer } from '@domain/app';
import { Card } from '@generated-types';
import useText from '@hooks/use-text';
import { isDebit } from '@utils/card-type-utils';
import { getCardDocumentsUrl } from '@utils/url/get-card-details-url-utils';

interface DocumentsProps {
    card: Card;
}

const Documents = ({ card }: DocumentsProps) => {
    const text = useText();
    const linkProducer = useLinkProducer();

    if (isDebit(card)) {
        return null;
    }

    return (
        <ListPanel
            data-track-id={piwik.cardDetails.cardAboutEntryButtonFakturaOgDokumenter.dataTrackId}
            data-track-linkname={piwik.cardDetails.cardAboutEntryButtonFakturaOgDokumenter.dataTrackLinkname}
            id="link-invoice"
            prefixContent={<Icon type={IconTypes.FAKTURA_24} />}
            url={getCardDocumentsUrl(card)(linkProducer)}
            title={text.documentsTitle}
            backgroundColor="light"
            icon={IconTypes.PIL_HOEYRE}
        />
    );
};

export default Documents;
